import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { ITheKnotAuthUrl } from '~/types/server.types';
import { IAppStates } from '~/apps/main/App/hooks/useNavigation.consts';

export class TheKnotAdapter extends BaseHttpAdapter {
    getAuthUrl(redirect_path: IAppStates | string) {
        return this.apiService.apiRequest<ITheKnotAuthUrl>({
            method: 'get',
            url: `/api/v2/integrations/tkww/auth_url?redirect_path=${redirect_path}`
        });
    }

    async disconnectTheKnot(companyId: string) {
        return this.apiService.apiRequest<void>({
            method: 'delete',
            url: `/api/v2/companies/${companyId}/integrations/tkww`
        });
    }

    async finalizeTheKnotIntegration(
        companyId: string,
        customerId: string,
        state: string
    ) {
        return this.apiService.apiRequest<void>({
            method: 'post',
            url: `/api/v2/companies/${companyId}/integrations/tkww`,
            data: { customer_id: customerId, state: state }
        });
    }
}
